export default __webpack_public_path__ + "976542514e15f63ca00b7ba5de2a8f48.png";